export type Service = {
  name: string;
  description: string;
  // Public subdomain in front of nginx-proxy, e.g. "invoicing" -> invoicing.<domain>.
  subdomain: string;
  // Optional deep link into the app.
  path?: string;
};

// Data-driven on purpose: this is the seam for baking in real logic later
// (health checks, auth-aware links, embedded widgets, etc.) without
// touching the page layout.

// The three prestations — the vet-facing workflows documented in the runbooks
// (tele-consultation, group lessons, teaching). Each is a shortcut into the
// tool where that workflow actually happens.
export const prestations: Service[] = [
  {
    name: "Télé-consultation",
    description: "Planifier une télé-consultation confraternelle (rendez-vous).",
    subdomain: "booking",
  },
  {
    name: "Leçons & séances",
    description: "Créer, planifier et rejoindre les leçons de groupe.",
    subdomain: "invoicing",
    path: "/lessons",
  },
  {
    name: "Enseignement & quiz",
    description: "Formulaires de préparation, quiz notés et résultats.",
    subdomain: "forms",
  },
];

// The underlying tools, reachable directly.
export const outils: Service[] = [
  {
    name: "Facturation & compta",
    description: "InvoiceNinja — fork français (grand livre / TVA).",
    subdomain: "invoicing",
  },
  {
    name: "Visioconférence",
    description: "Jitsi Meet — salles de consultation et de leçon.",
    subdomain: "meet",
  },
  {
    name: "Signature électronique",
    description: "DocuSeal — consentements et conventions.",
    subdomain: "sign",
  },
  {
    name: "Base de connaissances",
    description: "SiYuan — notes, comptes rendus et archives.",
    subdomain: "docs",
  },
  {
    name: "Site public",
    description: "Le site vitrine du Dr Canonne.",
    subdomain: "vet",
  },
];

// The portal is served at portal.<domain>; every other service is a sibling
// subdomain of the same base. Derive the base by dropping the "portal." prefix
// so the links follow the deployment automatically (no hard-coded domain).
export function baseDomainFrom(hostname: string): string {
  return hostname.replace(/^portal\./, "");
}

export function serviceUrl(baseDomain: string, service: Service): string {
  return `https://${service.subdomain}.${baseDomain}${service.path ?? ""}`;
}
